import { Component, OnInit, ViewChild } from '@angular/core';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service'
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component'
import { PagerService } from '../../Services/pager.service'
import { IDropdownSettings } from 'ng-multiselect-dropdown'
import { productionFilter, productionDetails, ProductionStatus } from "../../Models/Production/production"
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-production-packageing',
  templateUrl: './production-packageing.component.html',
  styleUrls: ['./production-packageing.component.css']
})
export class ProductionPackageingComponent implements OnInit {
 
  @ViewChild('RMHName') RMHName;
  @ViewChild('Brand') Brand;
  @ViewChild('requirementStatus') requirementStatus;
  @ViewChild('JobNumber') JobNumber;
  @ViewChild('State') State;
  @ViewChild('vendorType') vendorType;

  userID: string;
  roleID: string;

  selectModule: string;
  selectCheck: boolean = false;

  loader: string = 'none';
  selectedRMHName: string = '';
  selectedJobType: string = '';
  selectedBrand: string = '';
  selectedCrop: string = '';
  selectedLanguage: string = '';
  selectedMonth: string = '';
  selectedStatus:string='';
  selectedState:string='';
  selectedJobNumber:string='';
  selectedListVendor:string='';

  ascNumberSort: boolean = true;
  sortDirection: string = '';

  status: any;
  requirementId: string = '';
  additionalrequirementId: string = '';
  displayStatusPanel: string = 'none';
  productionStatus: ProductionStatus[] = [];
  statusIntegrate: ProductionStatus = new ProductionStatus();
  selectStatus: any;
  //Multiple dropdown select
  dropdownMonth = [];
  dropdownStatus=[];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  dropdownCropSettings: IDropdownSettings = {};
  dropdownBrandSettings: IDropdownSettings = {};
  dropdownJobTypeSettings: IDropdownSettings = {};
  dropdownLanguageSettings: IDropdownSettings = {};
  dropdownRmhsSettings: IDropdownSettings = {};
  dropdownstatusSettings: IDropdownSettings = {};
  dropdownJobNumbersSetting:IDropdownSettings={};
  dropdownstateSetting:IDropdownSettings={};
  dropdownVendorSettings:IDropdownSettings={};

  productionFilters: productionFilter = new productionFilter();
  productionDetails: productionDetails[] = [];

  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private router: Router, private snackBar: MatSnackBarComponent,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.selectModule="Packaging";
    this.selectStatus=8;
  }

  bindMonthDropdown() {
    this.dropdownMonth = [
      { item_id: 1, item_text: 'January' },
      { item_id: 2, item_text: 'February' },
      { item_id: 3, item_text: 'March' },
      { item_id: 4, item_text: 'April' },
      { item_id: 5, item_text: 'May' },
      { item_id: 6, item_text: 'June' },
      { item_id: 7, item_text: 'July' },
      { item_id: 8, item_text: 'August' },
      { item_id: 9, item_text: 'September' },
      { item_id: 10, item_text: 'October' },
      { item_id: 11, item_text: 'November' },
      { item_id: 12, item_text: 'December' }
    ];

    this.dropdownStatus = [
      { item_id: 7, item_text: 'Packaging In Process' },
      { item_id: 8, item_text: 'Dispatched by Printer' },
    ];

    this.dropdownstatusSettings={
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
  }
  bindDropdown() {
    this.dropdownCropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownBrandSettings = {
      singleSelection: false,
      idField: 'brandName',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownJobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownLanguageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownRmhsSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownJobNumbersSetting={
      singleSelection: false,
          idField: 'jobNumber',
          textField: 'jobNumber',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 2,
          allowSearchFilter: true,
          enableCheckAll: true
    };
    this.dropdownstateSetting={
          singleSelection: false,
          idField: 'stateID',
          textField: 'stateName',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          itemsShowLimit: 2,
          allowSearchFilter: true,
          enableCheckAll: true
    };
    this.dropdownVendorSettings={
      singleSelection: false,
      idField: 'vendorId',
      textField: 'vendorType',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }

  onItemSelect(event: any, filter: string) {
    if (filter == "Month") {
      this.selectedMonth += event.item_id + ',';

    }
    // if (filter == "RMH") {
    //   if (this.selectedRMHName.lastIndexOf(',') != this.selectedRMHName.length-1) {
    //     this.selectedRMHName += ','+ "'" + event.rMHCode + "'" + ',';
    //   }
    //   else {
    //     this.selectedRMHName += "'" + event.rMHCode + "'" + ',';
    //   }

    // }
    if (filter == "Crop") {
      this.selectedCrop += event.cropID + ',';

    }
    // if (filter == "Brand") {
    //   this.selectedBrand += "'" + event.brandName + "'" + ',';

    // }
    if (filter == "Language") {
      this.selectedLanguage += event.languageID + ',';

    }
    if (filter == "Jobtype") {
      this.selectedJobType += event.jobTypeID + ',';

    }
  }
  onSelectAll(event: any, filter: string) {

    if (filter == "Month") {
      this.selectedMonth = '';
      for (let item of event) {
        this.selectedMonth += item.item_id.toString() + ',';
      }

    }
    // if (filter == "RMH") {
    //   this.selectedRMHName = '';
    //   for (let item of event) {
    //     this.selectedRMHName += "'" + item.rMHCode.toString() + "'" + ',';
    //   }

    // }
    if (filter == "Crop") {
      this.selectedCrop = '';
      for (let item of event) {
        this.selectedCrop += item.cropID.toString() + ',';
      }

    }
    // if (filter == "Brand") {
    //   this.selectedBrand = '';
    //   for (let item of event) {
    //     this.selectedBrand += "'" + item.brandName.toString() + "'" + ',';
    //   }

    // }
    if (filter == "Language") {
      this.selectedLanguage = '';
      for (let item of event) {
        this.selectedLanguage += item.languageID.toString() + ',';
      }

    }
    if (filter == "Jobtype") {
      this.selectedJobType = '';
      for (let item of event) {
        this.selectedJobType += item.jobTypeID.toString() + ',';
      }

    }
  }
  deSelectAll(event: any, filter: string) {
    if (filter == "Month")
      this.selectedMonth = '';
    // if (filter == "RMH")
    //   this.selectedRMHName = '';
    if (filter == "Jobtype")
      this.selectedJobType = '';
    // if (filter == "Brand")
    //   this.selectedBrand = '';
    if (filter == "Crop")
      this.selectedCrop = '';
    if (filter == "Language")
      this.selectedLanguage = '';
  }
  unSelect(event: any, filter: string) {
    switch (filter) {
      case "Month":
        {
          if (this.selectedMonth.indexOf(event.item_id + ',') != -1) {
            this.selectedMonth = this.selectedMonth.replace(event.item_id + ',', '');
          }
          else {
            this.selectedMonth = this.selectedMonth.replace(event.item_id, '');
          }
          break;
        }
      // case "RMH":
      //   {
      //     if (this.selectedRMHName.indexOf("'" + event.rMHCode + "'" + ',') != -1) {
      //       this.selectedRMHName = this.selectedRMHName.replace("'" + event.rMHCode + "'" + ",", '');
      //     }
      //     else {
      //       this.selectedRMHName = this.selectedMonth.replace("'" + event.rMHCode + "'", '');
      //     }
      //     break;
      //   }
      case "Jobtype":
        {
          if (this.selectedJobType.indexOf(event.jobTypeID + ',') != -1) {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID + ',', '');
          }
          else {
            this.selectedJobType = this.selectedJobType.replace(event.jobTypeID, '');
          }
          break;
        }
      // case "Brand":
      //   {
      //     if (this.selectedBrand.indexOf("'" + event.brandName + "'" + ',') != -1) {
      //       this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'" + ",", '');
      //     }
      //     else {
      //       this.selectedBrand = this.selectedBrand.replace("'" + event.brandName + "'", '');
      //     }
      //     break;
      //   }
      case "Crop":
        {
          if (this.selectedCrop.indexOf(event.cropID + ',') != -1) {
            this.selectedCrop = this.selectedCrop.replace(event.cropID + ',', '');
          }
          else {
            this.selectedCrop = this.selectedCrop.replace(event.cropID, '');
          }
          break;
        }
      case "Language":
        {
          if (this.selectedLanguage.indexOf(event.languageID + ',') != -1) {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID + ',', '');
          }
          else {
            this.selectedLanguage = this.selectedLanguage.replace(event.languageID, '');
          }
          break;
        }
      default:
    }
  }
  ProductionPrintingfilter() {

    this.loader = 'block';
    this.mcPlanningMaterialService.getProductionFilter('Packageing')
      .subscribe((responsedata: any) => {
        if (responsedata.status == true) {
          this.productionFilters = responsedata.data;
          this.loader = 'none';
        }
        else {
          this.productionFilters = responsedata.data;
          this.loader = 'none';
        }
      })
  }
  GetProductionPackageingDetails() {
    this.selectCheck = false;
    this.selectedRMHName = Array.prototype.map.call(this.RMHName.selectedItems, function (item) { return "'"+ item.id+"'"; }).join(",");// this.selectedRMHName.lastIndexOf(",") == this.selectedRMHName.length - 1 ? this.selectedRMHName.substring(0, this.selectedRMHName.lastIndexOf(",")) : this.selectedRMHName;
    this.selectedMonth = this.selectedMonth.lastIndexOf(',') == this.selectedMonth.length - 1 ? this.selectedMonth.substring(0, this.selectedMonth.length - 1) : this.selectedMonth;
    this.selectedCrop = this.selectedCrop.lastIndexOf(",") == this.selectedCrop.length - 1 ? this.selectedCrop.substring(0, this.selectedCrop.length - 1) : this.selectedCrop;
    this.selectedBrand = Array.prototype.map.call(this.Brand.selectedItems, function (item) { return "'"+ item.id+"'"; }).join(",");//this.selectedBrand.lastIndexOf(",") == this.selectedBrand.length - 1 ? this.selectedBrand.substring(0, this.selectedBrand.lastIndexOf(",")) : this.selectedBrand;
    this.selectedLanguage = this.selectedLanguage.lastIndexOf(",") == this.selectedLanguage.length - 1 ? this.selectedLanguage.substring(0, this.selectedLanguage.length - 1) : this.selectedLanguage;
    this.selectedJobType = this.selectedJobType.lastIndexOf(",") == this.selectedJobType.length - 1 ? this.selectedJobType.substring(0, this.selectedJobType.length - 1) : this.selectedJobType;
    this.selectedStatus=Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return  item.id; }).join(",");
    if(this.selectedStatus.length==0)
    this.selectedStatus = this.selectModule == "Printing" ? '6,7,8,9,10,11,12' : '7,8,9,10,11,12';;
    this.selectedJobNumber=Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return "'"+ item.id+"'"; }).join(",");
    this.selectedState=Array.prototype.map.call(this.State.selectedItems, function (item) { return "'"+ item.id+"'"; }).join(",");
    this.selectedListVendor=Array.prototype.map.call(this.vendorType.selectedItems, function (item) { return item.id; }).join(",");

    this.mcPlanningMaterialService.getProductionDetails(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.selectedMonth, this.selectedStatus, this.selectedJobNumber,this.selectedState,this.selectedListVendor)
      .subscribe((responseData: any) => {
        if (responseData.status == true) {
          this.productionDetails = responseData.data;
          this.loader = 'none';
        }
        else {
          this.productionDetails = responseData.data;
          this.toastr.error('No records Available');
          this.loader = 'none';
        }
      })

  }
  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.bindMonthDropdown();
    this.bindDropdown();
    this.GetProductionPackageingDetails();
    this.bindProductionStatus();
    this.ProductionPrintingfilter()
  }

  GetcheckedItem() {
    this.productionDetails.forEach(element => {
      if (this.selectCheck == false)
      {
        if(element.requirementType==1 && element.status=='Packaging In Process')
        this.requirementId += element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailsID + ",";
        else
        if(element.status=='Packaging In Process')
        this.additionalrequirementId+= element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailsID + ",";
      }
      else
        if(element.requirementType==1  && element.status=='Packaging In Process')
        this.requirementId += element.requirementDetailsID + ",";
        else
        if(element.status=='Packaging In Process')
        this.additionalrequirementId+=  element.requirementDetailsID + ",";
    });
    //if (this.requirementId.trim().length > 0 || this.additionalrequirementId.trim().length > 0)
     // this.submitProductionStatus();
  }
  checkSelected(index: number) {
    if (!this.productionDetails[index]["isSelected"]) {
      if(this.productionDetails[index]["requirementType"]==1 && this.productionDetails[index]["status"]=='Packaging In Process')
      this.requirementId.trim().replace(this.productionDetails[index]["requirementDetailsID"] + ',', '');
      else
      if(this.productionDetails[index]["status"]=='Packaging In Process')
      this.additionalrequirementId.trim().replace(this.productionDetails[index]["requirementDetailsID"] + ',', '');
      this.selectCheck = false;
    }
  }
  SelectAll() {
    this.productionDetails.forEach(element => {
      if (this.selectCheck == true && element.status=='Packaging In Process')
        element.isSelected = true;
      else {
        if(element.status=='Packaging In Process')
        element.isSelected = false;
        this.requirementId = "";
        this.additionalrequirementId = "";
      }
    })
  }
  ChangeModule() {
    this.GetProductionPackageingDetails();
    this.ProductionPrintingfilter();
    this.bindProductionStatus();
    this.selectCheck = false;
  }
  closeStatusPanel() {
    this.displayStatusPanel = 'none';
    this.requirementId = '';
  }
  bindProductionStatus() {
    this.productionStatus = [];
  // for (let i = 1; i <= 2; i++) {

     // if (i == 1) {
        if (this.selectModule == "Printing") {
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 6;
          this.statusIntegrate.StatusName = "Printing in process";
          this.productionStatus.push(this.statusIntegrate)
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 7;
          this.statusIntegrate.StatusName = "Printing Done";
          this.productionStatus.push(this.statusIntegrate)
        }
        else {
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 7;
          this.statusIntegrate.StatusName = "Packaging in process";
          this.productionStatus.push(this.statusIntegrate)
          this.statusIntegrate = new ProductionStatus();;
          this.statusIntegrate.StatusID = 8;
          this.statusIntegrate.StatusName = "Packaging Done";
          this.productionStatus.push(this.statusIntegrate)
        }
   //   }
      // else {
      //   if (this.selectModule == "Printing") {
      //     this.statusIntegrate.StatusID = 11;
      //     this.statusIntegrate.StatusName = "Printing Done";
      //   }
      //   else {
      //     this.statusIntegrate.StatusID = 13;
      //     this.statusIntegrate.StatusName = "Packageing Done";
      //   }
      // }
 //   }
  }
  // submitProductionStatus()
  // {
   
  //   this.mcPlanningMaterialService.updateProductionPackageingStatus(this.requirementId,this.selectStatus,this.additionalrequirementId)
  //   .subscribe((responseData: any) => {
  //     if (responseData.status) {
  //       this.toastr.error('Status Updated Successfully', 'Close', 'green-snackbar');
  //       this.loader = 'none';
  //       this.displayStatusPanel='none';
  //       this.GetProductionPackageingDetails();
  //     }
  //     else {
  //       this.toastr.error('Some error Occured,Could not update status', 'Close', 'red-snackbar');
  //       this.loader = 'none';
  //       this.displayStatusPanel='none';
  //       this.GetProductionPackageingDetails();
  //     }
  //   })
  // }
  changeStatus(details:any)
  {
    if(this.selectModule == "Printing")
    {
      this.selectStatus=7;
    }
    else
    this.selectStatus=8;
    if(details.requirementType=="1")
    this.requirementId=details.requirementDetailsID
    else
    this.additionalrequirementId=details.requirementDetailsID
    //this.submitProductionStatus();
  }

  sort() {
    let sortedArray : any[] = [];
    let splitString : any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownMonth.forEach(x => {
        this.productionDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.productionDetails = sortedArray;
    }
    else {
      this.dropdownMonth.forEach(x => {
        this.productionDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.productionDetails = sortedArray.reverse();
    }
  }
}
